import { createContext, use } from 'react';

import { DEFAULT_LOCALE, translate, type Locale } from '@/i18n/locale';
import type { Translate } from '@/i18n/types';

export interface LocaleContextValue {
  locale: Locale;
  /** A guest's manual choice. A signed-in account's own setting outranks it. */
  setLocale: (locale: Locale) => void;
  t: Translate;
}

/**
 * Defaulted rather than nullable so a component rendered outside the provider —
 * only ever a test — reads English instead of throwing.
 *
 * Kept apart from the provider component because the lint rule guarding fast
 * refresh rejects a module that exports both hooks and components.
 */
export const LocaleContext = createContext<LocaleContextValue>({
  locale: DEFAULT_LOCALE,
  setLocale: () => {},
  t: (key, params) => translate(DEFAULT_LOCALE, key, params),
});

export function useLocale(): LocaleContextValue {
  return use(LocaleContext);
}

export function useT(): Translate {
  return use(LocaleContext).t;
}
